import ee from './ee'
import hamburgerUrl from './textures/hamburger.png'
import React, { Component } from 'react'
import { render } from 'react-dom'
import state from './state'
import textureUrls from './textures/urls'
import toDataURL from '@packages/data-url'

class InfoContainer extends Component {
  interval

  state = {
    checkboxes: {},
    score: state.game.score,
    showImageUrlBox: false,
    sliders: {},
    tall: true,
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ score: state.game.score })
    }, 250)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onCheckboxChange = (name: string): void => {
    return (e) => {
      let val = false
      try {
        val = !this.state.checkboxes[name]
      } catch (e) {}
      console.log(name, val)
      // Set UI info checkboxes state
      this.setState({
        checkboxes: {
          ...this.state.checkboxes,
          [name]: val,
        },
      })

      switch (name) {
        case 'arm_auto_spin':
          state.objects.base.arm.movement = val ? 5 : 0
          break
      }

      this.resetLevel()
    }
  }

  onClickHamburger = (e) => {
    e && e.preventDefault()

    // Toggle whether to expand the menu
    this.setState({ tall: !this.state.tall })
  }

  onClickTexture = (key: string) => {
    return (e) => {
      e && e.preventDefault()

      state.game.textureUrl = textureUrls[key]

      this.resetLevel()
    }
  }

  onClickOwnTexture = (e) => {
    e && e.preventDefault()

    this.setState({ showImageUrlBox: true })
  }

  onImageUrlBoxChange = (e) => {
    e && e.preventDefault()
    const url = e.target.value

    toDataURL(url, (url) => {
      const tUrl = (textureUrls[Date.now()] = url)
      state.game.textureUrl = tUrl

      this.setState({ showImageUrlBox: false })

      this.resetLevel()
    })
  }

  onSliderChange = (name: string): void => {
    return (e) => {
      const val = parseInt(e.target.value)

      // Set UI info sliders state
      this.setState({
        sliders: {
          ...this.state.sliders,
          [name]: val,
        },
      })

      // Set game state
      switch (name) {
        case 'arm_rot_speed':
          state.objects.base.arm.rotationSpeed = val
          break
        case 'ball_mass':
          state.objects.ball.mass = val
          break
        case 'ball_radius':
          state.objects.ball.radius = val / 10
          break
        case 'brick_mass':
          state.objects.wall.brick.mass = val / 2
          break
        case 'brick_size':
          state.objects.wall.brick.depth = val
          state.objects.wall.brick.length = val
          break
        case 'gravity':
          state.physics.gravity.constant = val
          break
        case 'level_rounds':
          state.game.numRounds = val
          break
        case 'wall_height':
          state.objects.wall.height = val
          break
        case 'wall_width':
          state.objects.wall.width = val
          break
      }

      this.resetLevel()
    }
  }

  resetLevel = (e?) => {
    e && e.preventDefault()

    // Reset level with new values
    ee.emit('reset-level')
  }

  renderCheckbox({ checked = false, label, name }) {
    const c = this.state.checkboxes[name] || checked

    return (
      <div className="row">
        <input
          className="checkbox"
          type="checkbox"
          name={name}
          checked={c}
          onChange={this.onCheckboxChange(name)}
        />
        <label className="checkbox-label" htmlFor={name}>
          {label}
        </label>
      </div>
    )
  }

  renderControlsHowTo() {
    return (
      <div id="controls-how-to-container" className="row">
        <h6>Controls:</h6>
        <p>A or D to move arm</p>
        <p>Space to release ball (and rope)</p>
        <p>Click the hamburger in the top right to minimize this menu</p>
      </div>
    )
  }

  renderForceReset() {
    return null // Don't render the button

    return (
      <div className="row center space">
        <button id="force-reset" onClick={this.resetLevel}>
          Force Reset
        </button>
      </div>
    )
  }

  renderSlider({ defaultValue, label, max, min, name, step }) {
    const value = this.state.sliders[name] || defaultValue

    return (
      <div className="row">
        <input
          className="slider"
          type="range"
          name={name}
          min={min}
          max={max}
          onChange={this.onSliderChange(name)}
          value={value}
          step={step}
        />
        <span className="slider-value">
          {value > 0 && value < 10 ? '0' + value : value}
        </span>
        <label className="slider-label" htmlFor={name}>
          {label}
        </label>
      </div>
    )
  }

  renderTextureChoice({ key, url }) {
    return (
      <li className="texture-item" key={key} onClick={this.onClickTexture(key)}>
        <img src={url} />
      </li>
    )
  }

  renderTextureChoices() {
    const Choices = []

    for (const [key, value] of Object.entries(textureUrls)) {
      if (key != 'plus') {
        Choices.push(this.renderTextureChoice({ key, url: value }))
      }
    }

    // Render plus last
    Choices.push(this.renderTextureOwnChoice())

    return <ul className="textures-list">{Choices}</ul>
  }

  renderTextureOwnChoice() {
    return (
      <li
        className="texture-item"
        key={'own-texture'}
        onClick={this.onClickOwnTexture}
      >
        <img src={textureUrls.plus} />
      </li>
    )
  }

  renderImageUrlBox() {
    if (this.state.showImageUrlBox) {
      return (
        <div id="image-url-box-container">
          <h3>Paste image url to add texture</h3>
          <p>
            Images can take anywhere from a few seconds to a minute to load
            depending on the size of the image and your internet connection
            speed.
          </p>
          <input
            autoFocus={true}
            id="image-url-box"
            onChange={this.onImageUrlBoxChange}
            type="text"
          />
        </div>
      )
    }

    return null
  }

  render() {
    return (
      <div
        id="info-inner-container"
        className={this.state.tall ? 'info-inner-container__tall' : ''}
      >
        <div id="hamburger-container">
          <img
            id="hamburger-icon"
            src={hamburgerUrl}
            onClick={this.onClickHamburger}
          />
        </div>
        {this.renderImageUrlBox()}
        <div className="row">
          <span id="score">{this.state.score}</span>
          <span id="score-label">Score</span>
        </div>
        {this.renderCheckbox({ label: 'Autospin Arm', name: 'arm_auto_spin' })}
        {this.renderSlider({
          defaultValue: 20,
          label: 'Arm Speed',
          max: 40,
          min: 5,
          name: 'arm_rot_speed',
          step: 5,
        })}
        {this.renderSlider({
          defaultValue: 5,
          label: 'Ball Mass',
          max: 20,
          min: 1,
          name: 'ball_mass',
          step: 1,
        })}
        {this.renderSlider({
          defaultValue: 5,
          label: 'Ball Radius',
          max: 20,
          min: 1,
          name: 'ball_radius',
          step: 1,
        })}
        {this.renderSlider({
          defaultValue: 1,
          label: 'Brick Mass',
          max: 10,
          min: 1,
          name: 'brick_mass',
          step: 1,
        })}
        {this.renderSlider({
          defaultValue: 2,
          label: 'Brick Size',
          max: 3,
          min: 1,
          name: 'brick_size',
          step: 1,
        })}
        {this.renderSlider({
          defaultValue: -10,
          label: 'Gravity',
          max: -1,
          min: -20,
          name: 'gravity',
          step: 1,
        })}
        {this.renderSlider({
          defaultValue: 3,
          label: 'Level Rounds',
          max: 5,
          min: 1,
          name: 'level_rounds',
          step: 1,
        })}

        <div className="row space">
          <h3 className="texture-header">Choose a texture</h3>
          {this.renderTextureChoices()}
        </div>
        {this.renderControlsHowTo()}
        {this.renderForceReset()}
      </div>
    )
  }
}

render(<InfoContainer />, document.getElementById('info-container'))
